import { useMutation } from "@apollo/react-hooks";
import { useAsyncCallback } from 'react-use-async-callback';
import gql from "graphql-tag";
import { AsyncActionStatus } from '../../../shared/abstractStore';
import { LearningUnitCreateInput } from '../generated/globalTypes';
import { createLearningUnitMutation, createLearningUnitMutationVariables } from '../generated/createLearningUnitMutation';
import { learningUnitFieldsFragment } from '../models/LearningUnit';

/**
 * Get a callback to create a LearningUnit in the store.
 */
export function useCreateLearningUnitCallback(): [(model: LearningUnitCreateInput) => Promise<void>, AsyncActionStatus] {
    const [mutationAction, { error }] = useMutation<createLearningUnitMutation, createLearningUnitMutationVariables>(
        gql`
            mutation createLearningUnitMutation ($model: LearningUnitCreateInput!) {
                createLearningUnit(model: $model) {
                    ...learningUnitFields
                }
            }

            ${learningUnitFieldsFragment}
        `
    );

    // Wrap the mutation in a standard callback.
    const [action, { isExecuting, errors: actionErrors }] = useAsyncCallback(async (model: LearningUnitCreateInput) => {
        const result = await mutationAction({ variables: { model: model } });
        if (result.errors && result.errors.length) {
            throw result.errors;
        }
    }, [mutationAction]);

    return [action, { isExecuting: isExecuting, errors: error ? error.message : actionErrors }];
}
